import Keycloak from 'keycloak-js';
import { KeycloakConfig } from './KeycloakConfig';
import cookie from 'react-cookie';

class KeycloakService {
  constructor() {
    this.DATA_EXPIRACAO_TOKEN = 7;
  }

  isLogged() {
    return this.keycloak?.authenticated || false;
  }

  getUser() {
    return this.keycloak.loadUserInfo();
  }

  redirectToUserProfile() {
    return this.keycloak.accountManagement();
  }

  login(onLogin) {
    return this.keycloak
      .init({ onLoad: 'login-required' })
      .then(authenticated => {
        if (!authenticated) {
          return Promise.reject(new Error('Usuário não autenticado'));
        }
        onLogin && onLogin(authenticated);
        return authenticated;
      });
  }

  loadLoggedUser() {
    return this.keycloak
      .init({ onLoad: 'login-required' })
      .then(authenticated => {
        if (!authenticated) {
          return Promise.reject(new Error('Usuário não autenticado'));
        }
        return authenticated;
      });
  }

  checkSSO({ token, refreshToken }) {
    return this.keycloak.init({
      onLoad: 'check-sso',
      token,
      refreshToken
    });
  }

  logout() {
    this.keycloak.logout();
  }

  getToken() {
    return this.keycloak?.token;
  }

  getRefreshToken() {
    return this.keycloak?.refreshToken;
  }

  refreshToken() {
    return this.keycloak.updateToken(30);
  }

  getTokenParsed() {
    return this.keycloak.tokenParsed;
  }

  hasRole(role) {
    return this.keycloak.hasResourceRole(role, 'portal-transparencia-backend');
  }

  setKeycloakUser(usuarioInfo) {
    cookie.save(
      'keycloakUser',
      JSON.stringify(usuarioInfo),
      this.DATA_EXPIRACAO_TOKEN,
      '/',
      window.location.hostname
    );
  }

  getKeycloakUser() {
    return cookie.load('keycloakUser');
  }

  setusuarioLogado() {
    cookie.save('usuarioLogado', true);
  }

  getUsuarioLogado() {
    return cookie.load('usuarioLogado');
  }

  setConfig(onPremise) {
    this.keycloak = new Keycloak(KeycloakConfig.config(onPremise));
  }
}
const keycloakService = new KeycloakService();

export default keycloakService;
